import { FC, ReactNode } from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  SimpleGrid,
} from "@chakra-ui/react";

interface IntegrationsSectionProps {
  content: {
    title: string;
    subtitle: string;
  };
  children: ReactNode;
}

export const IntegrationsSection: FC<IntegrationsSectionProps> = ({
  content,
  children,
}) => (
  <Box py={{ base: "16", md: "24" }} bg="gray.50">
    <Container maxW="7xl">
      <VStack spacing="12">
        {/* Section Header */}
        <VStack spacing="4" textAlign="center" maxW="3xl">
          <Heading
            as="h2"
            fontSize={{ base: "3xl", md: "4xl", lg: "5xl" }}
            fontWeight="bold"
            color="gray.900"
          >
            {content.title}
          </Heading>
          <Text
            fontSize={{ base: "lg", md: "xl" }}
            color="gray.600"
            lineHeight="tall"
          >
            {content.subtitle}
          </Text>
        </VStack>

        {/* Integration Cards */}
        <SimpleGrid
          columns={{ base: 1, md: 2, lg: 3 }}
          spacing="8"
          w="full"
          maxW="7xl"
        >
          {children}
        </SimpleGrid>
      </VStack>
    </Container>
  </Box>
);
